interface AvatarProps {
    name: string;
    color?: string;
    size?: "sm" | "md";
  }
  
  const getInitials = (name: string) => {
    const parts = name.split(" ");
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  };
  
  const colorClasses: Record<string, string> = {
    purple: "bg-primary text-primary-foreground",
    pink: "bg-pink-400 text-white",
    blue: "bg-blue-400 text-white",
    green: "bg-emerald-400 text-white",
    orange: "bg-orange-400 text-white",
  };
  
  const Avatar = ({ name, color = "purple", size = "md" }: AvatarProps) => {
    const sizeClasses = size === "sm" ? "w-8 h-8 text-xs" : "w-10 h-10 text-sm";
  
    return (
      <div
        className={`${sizeClasses} ${colorClasses[color] || colorClasses.purple} rounded-full flex items-center justify-center font-semibold`}
      >
        {getInitials(name)}
      </div>
    );
  };
  
  export default Avatar;